"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ceccano": {
    "fb6c8982": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "skipSearch": false
    }],
    "acqua-santa": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "75aaa7d9": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "skipSearch": false
    }],
    "cantinella": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d6c5dd71": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "skipSearch": false
    }],
    "cardegna": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "56824040": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "skipSearch": false
    }],
    "casamarciano": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "54711005": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "skipSearch": false
    }],
    "celleta": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a58084dc": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "skipSearch": false
    }],
    "colle-alto": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b852f321": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "skipSearch": false
    }],
    "colle-antico": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "80be8ec0": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "skipSearch": false
    }],
    "colle-leo": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7b035ded": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "skipSearch": false
    }],
    "colle-san-paolo": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8fa26ad3": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "skipSearch": false
    }],
    "faito": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b6371c65": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "skipSearch": false
    }],
    "fiano": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4e111c19": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "skipSearch": false
    }],
    "maiura": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5e413100": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "skipSearch": false
    }],
    "peschiera": [{
      "hkey": "309acb59",
      "slug": "ceccano",
      "name": "Ceccano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;